export default "__VITE_ASSET__Dch2uRXs__"